namespace SP.Data {

    export interface RefillLotResponse {
        itemId: string,
        lots: StockingLotInfo[]
    }
    export class StockingLot {
        //private static stockingLotInfo: { [lotId: string]: StockingLotInfo } = {};
        //private static arrivalStockingLotInfos: { [arrivalId: string]: StockingLotInfo[] } = {};
        //private static barcodeStockingLotInfos: { [barcode: string]: StockingLotInfo[] } = {};
        //private static placementStockingLotInfos: { [placementId: number]: StockingLotInfo[] } = {};
        //private static itemStockingLotInfos: { [itemId: string]: StockingLotInfo[] } = {};

        static async getStockingLotInfo(lotId: string, useCache = true) {
            //if (useCache && this.stockingLotInfo[lotId] != null) return this.stockingLotInfo[lotId];
            var response = await SP.get<any>("/api/v1/info/stockingLotInfo/" + lotId);
            if (response.status == 200) return response.data as StockingLotInfo;// this.stockingLotInfo[lotId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
            //return this.stockingLotInfo[lotId];
        }

        static async getArrivalStockingLotInfos(arrivalId: string, useCache = true) {
            //if (useCache && this.arrivalStockingLotInfos[arrivalId] != null) return this.arrivalStockingLotInfos[arrivalId];
            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?arrivalId=" + arrivalId);
            if (response.status == 200) return response.data as StockingLotInfo[];// this.arrivalStockingLotInfos[arrivalId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
            //return this.arrivalStockingLotInfos[arrivalId];
        }

        static async getBarcodeStockingLotInfos(barcode: string, useCache = true) {
            //if (useCache && this.barcodeStockingLotInfos[barcode] != null) return this.barcodeStockingLotInfos[barcode];
            var bc = encodeURIComponent(barcode);
            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?barcode=" + bc);
            if (response.status == 200) return response.data as StockingLotInfo[];// this.barcodeStockingLotInfos[barcode] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
            //return this.barcodeStockingLotInfos[barcode];
        }

        static async getPlacementStockingLotInfos(placementId: number) {
            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?maxResults=1000&placementId=" + placementId);
            if (response.status == 200) return response.data as StockingLotInfo[];// this.placementStockingLotInfos[placementId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
            //return this.placementStockingLotInfos[placementId];
        }


        static async getItemStockingLotInfos(itemId: string, useCache = true) {
            //if (useCache && this.itemStockingLotInfos[itemId] != null) return this.itemStockingLotInfos[itemId];
            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?itemId=" + itemId);
            if (response.status == 200) return response.data as StockingLotInfo[];// this.itemStockingLotInfos[itemId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
            //return this.itemStockingLotInfos[itemId];
        }


        static async getRefillStockingLotInfos() {
            //if (useCache && this.itemStockingLotInfos[itemId] != null) return this.itemStockingLotInfos[itemId];
            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?refill=true");
            if (response.status == 200) return response.data as [{ key: string, value: ItemRefillInfo[]  }];// this.itemStockingLotInfos[itemId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
            //return this.itemStockingLotInfos[itemId];
        }

    }
}